import {resolveServerErrorMessage} from "./resolveServerErrorMessage";

// Meldungen der Server-Guards für Datensätze nach DSGVO-Löschantrag (src/server/erasure/erasureGuard.ts,
// invoice.service.v2.ts). Resolver packen sie teils in „Bad Request: …“ ein, daher ab dem Treffer schneiden.
const ERASED_RECORD_PATTERN = /(Datensatz ist nach DSGVO-Löschantrag eingeschränkt|Buchungen eingeschränkter Datensätze)[\s\S]*/;

/** Guard-Meldung des Servers, wenn der Fehler von einem eingeschränkten Datensatz kommt; sonst `undefined`. */
export const erasedRecordMessage = (error: unknown): string | undefined => {
    const match = ERASED_RECORD_PATTERN.exec(resolveServerErrorMessage(error, ""));

    return match ? match[0] : undefined;
};

/** Tooltip an Aktionen, die der Server für eingeschränkte Datensätze ablehnt. */
export const ERASED_ACTION_HINT = "Nach DSGVO-Löschantrag gesperrt: der Datensatz ist eingeschränkt.";

// Platzhalter der Löschung (src/server/erasure/erasureMatrix.ts): Name und Geburtstag. Der Client
// importiert kein Server-Modul, daher hier gespiegelt; tests/unit/erasure/erasedPlaceholders.sync.test.ts
// vergleicht beide Seiten.
export const ERASED_FIRSTNAME = "Gelöscht";
export const ERASED_LASTNAME = "(DSGVO)";
/** attendee.birthday ist Pflichtfeld; die Löschung setzt diesen Wert. 1970-01-01 ist der ältere Platzhalter „kein Geburtsdatum“. */
const PLACEHOLDER_BIRTHDAYS = ["1900-01-01", "1970-01-01"];

/** Kein echtes Geburtsdatum: leer oder einer der Platzhalter (nur der Datumsteil zählt). */
export const isPlaceholderBirthday = (value: string | Date | null | undefined): boolean => {
    if (!value) return true;
    const iso = value instanceof Date ? value.toISOString() : value;

    return PLACEHOLDER_BIRTHDAYS.indexOf(iso.substring(0, 10)) !== -1;
};

export const isErasedName = (firstname?: string | null, lastname?: string | null): boolean => firstname === ERASED_FIRSTNAME && lastname === ERASED_LASTNAME;
